import React, {useState, useContext} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Select from 'react-select';

// Alertas
import Swal from 'sweetalert2'

//Estilos
import './FormNivel3.css';
import { PRINCIPAL, NAVBARS, COLOR_BOTONES } from '../../constants/colors';

//Contextos
import nivel3Context from '../../context/nivel3Context/nivel3Context';
import activoContext from '../../context/activoContex/activoContex';
import { estructuraNivel1 } from '../../utils/estructuras';
import DictionaryText from '../dictionaryText/DictionaryText';
import clienteAxios from '../../config/axios';

function FormNivel3({ data, minimizar, nuevoEditado, formDato, handleChangeUbicaciones, generar = () => console.log("Generando"), listaUsuarios = [], setNivel3Seleccionada, optionsNivel2, nivel2List, nivel2Seleccionada, modo, i=-1 }) {

    // context agregarActivo - modificarrActivo
    const {actualizaractivoList} = useContext(activoContext)

    const pContext = useContext(nivel3Context);
    const {agregarNivel3, actualizarNivel3, modificarNivel3, eliminarNivel3} = pContext;

    //State de usuario. Si no viene data por parametro significa que es nuevo por lo que se le asigna una estructura.
    const [nivel3, setNivel3] = useState((data !== undefined && nuevoEditado == 'Modificar') ? {group: {codNivel3: data?.codNivel3, name: data?.nameNivel3 ? data?.nameNivel3 : data?.name, descrp:data?.descrp, id: data?.id, codNivel2: nivel2Seleccionada?.codNivel2, direccion: data?.direccion || '', lat: data?.lat || null, lng: data?.lng || null}} : {group: { codNivel3: "" ,name:"", descrp:"",codNivel2: nivel2Seleccionada.codNivel2, direccion: '', lat: null, lng: null}, members: []});
    const [opcionSeleccionada, setOpcionSeleccionada] = useState(null);

    const areaSeleccionadaNormalizada = {
        value: nivel2Seleccionada?.name || nivel2Seleccionada?.label,
        label: nivel2Seleccionada?.name || nivel2Seleccionada?.label,
        // Resto de las propiedades que quieras copiar
        codNivel2: nivel2Seleccionada?.codNivel2,
        descrp: nivel2Seleccionada?.descrp,
        id: nivel2Seleccionada?.id,
        
    };

    const nivel2SeleccionadaValue = nivel2Seleccionada?.value !== undefined ? 
        {...nivel2Seleccionada, value: nivel2Seleccionada.name, label: nivel2Seleccionada.name } 
        : nivel2Seleccionada;

                  
    //Constante que define el titulo que corresponde si vienen datos por parametros
    const [titulo, setTitulo] = useState(nuevoEditado)

    //Funcion de validacion
    const validacion =  () => { 
        const newErrors = {};

        if (nivel3.group.codNivel3 === '' || nivel3.group.codNivel3 === undefined) return newErrors.codigo = 'El código debe ser colocado';
        if (nivel3.group.name === '' || nivel3.group.codNivel3 === undefined) return newErrors.nombre = 'El nombre debe ser colocado';
        if (nivel3.group.descrp === '' || nivel3.group.descrp === undefined) return newErrors.nombre = 'La descripción debe ser colocada';

        return '';    
    };

    const handleGeocodificar = async () => {
        try {
            const resp = await clienteAxios.get(`/geocode?address=${encodeURIComponent(nivel3.group.direccion)}`);
            const { lat, lng } = resp.data.data;
            setNivel3({ ...nivel3, group: { ...nivel3.group, lat, lng } });
        } catch (err) {
            Swal.fire({ icon: 'warning', title: 'No se pudo geocodificar',
                text: err.response?.data?.message || 'Verifique la direccion ingresada' });
        }
    };

    // manda los datos al back
    const handlerGenerar = async () => {

        const errorAxi = validacion();

        if (errorAxi === "" ) {

            try {
                // const dato = nivel3.group;
                // Destructura nivel3 para obtener la propiedad group
                const { group } = nivel3;

                // Crea un nuevo objeto sin la propiedad id
                const { id, ...datoSinId } = group;
                //compara el name del Select con el name de la la DB para mandar info a la DB
                
                const filtro = nivel2List?.filter(dato => dato?.name === nivel2SeleccionadaValue?.name && dato?._id == nivel2SeleccionadaValue?.id)
                
                const nivel2Nivel3 = filtro[0]

                const datos = {...datoSinId, nivel2Nivel3}

                const res = await agregarNivel3(datos)
                console.log("res");
                console.log(res);
                
                if (res !== null) {
                    Swal.fire({
                        title: `Guardado exitosamente!`,
                        icon: 'success',
                        text: `Código: ${res.lv3Saved.codNivel3} \n Nombre: ${res.lv3Saved.nameNivel3}`,
                        showConfirmButton: true,
                        allowEnterKey: true
                    });     
                    actualizarNivel3();
                    actualizaractivoList(); 
                    minimizar();
                } else {
                    Swal.fire({
                    title:  "Se esta repitiendo el código o el nombre",
                    icon: 'warning',
                    showConfirmButton: true,
                    allowEnterKey: true
                    });
                }
            } catch (error) {
                console.log(error);
            }
        }else{
            Swal.fire({
                title: errorAxi,
                icon: 'warning',
                showConfirmButton: true,
                allowEnterKey: true
            });
        }
    }

    const handlerModificar = async () => {
        const errorAxi = validacion();

        if (errorAxi === "") {

            try {
                const dato = {
                    id: nivel3.group.id === undefined ? data[0]._id : nivel3.group.id,
                    codNivel3: nivel3.group.codNivel3,
                    name: nivel3.group.name,
                    descrp: nivel3.group.descrp,
                    codNivel2: nivel2Seleccionada.codNivel2,
                    nivel3Nivel2ID: data.nivel3Nivel2ID,
                    direccion: nivel3.group.direccion,
                    lat: nivel3.group.lat,
                    lng: nivel3.group.lng
                }
                
                const res = await modificarNivel3(dato);
                
                if (res !== null) {
                    Swal.fire({
                        title: `Modificado exitosamente!`,
                        icon: 'success',
                        text: `Código: ${res.codNivel3} \n Nombre: ${res.nameNivel3}`,
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                    actualizarNivel3();
                    actualizaractivoList();
                    minimizar({...dato, label: res.nameNivel3, value:res.nameNivel3});
                } else {
                    Swal.fire({
                        title:  "Se esta repitiendo el código o nombre",
                        icon: 'warning',
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                }
            } catch (error) {
                console.log(error);
            }
        }else{
                Swal.fire({
                    title: errorAxi,
                    icon: 'warning',
                    showConfirmButton: true,
                    allowEnterKey: true
                });
        } 
    }

    //lee lo que esta en el Select
    const handleChange = (selectedOption) => {
        setOpcionSeleccionada(selectedOption);
    }

    const handlerEliminar = () => {
        Swal.fire({
            title: `Estas seguro que deseas eliminar ${data.label}?`,
            icon: 'warning',
            text: `Se eliminara permanentemente!`,
            showConfirmButton: true,
            showCancelButton: true, // Habilita el botón de cancelar
            confirmButtonText: 'Borrar',
            cancelButtonText:'No, cancelar',
            allowEnterKey: true

        }).then(async (result) => {
            const dato = {
                id: data.id,
                codNivel3: nivel3.group.codNivel3,
                name: nivel3.group.name,
                descrp: nivel3.group.descrp,
                codNivel2:data.codNivel2,
                nivel3Nivel2ID: data.nivel3Nivel2ID,
            }
            if (result.isConfirmed) {
              // El usuario hizo clic en "Aceptar"
                const id = data.id
                const resp = await eliminarNivel3(id);

                if(resp === "No se puede borrar el nivel3 porque contiene un Activo") {
                    Swal.fire({
                        title: `No puede eliminarse!`,
                        icon: 'warning',
                        text: `Para poder eliminarlo no tiene que tener activos`,
                        showConfirmButton: true,
                        allowEnterKey: true
                        
                    })
                    minimizar({label: dato?.name, value:dato?.name});
                }else{
                    Swal.fire({
                        title: `Borrado!`,
                        icon: 'success',
                        text: `Eliminado correctamente!`,
                        showConfirmButton: true,
                        allowEnterKey: true
                    })
                    actualizaractivoList();
                    actualizarNivel3();
                    minimizar(null);                
                    handleChangeUbicaciones({},i,'nivel3',{...estructuraNivel1})

                }
                
            } else if (result.isDismissed) {
             // El usuario hizo clic en "Cancelar" o en cualquier otro lugar fuera del diálogo
                minimizar({label: dato?.name, value:dato?.name});
            }
            });
    }

  return (
    <div className='container-group-form'>
            <div className='title-form-group'  style={{backgroundColor: PRINCIPAL, color:NAVBARS}} >
                {titulo} <DictionaryText text={"Nivel3"}/>
            </div>

            <div className='container-form'>
                <div className='label-form-group'>Código: </div>
                <input  disabled={ titulo === "Modificar"} value={nivel3.group.codNivel3} className='label-form-group-data' onChange={data => setNivel3({ ...nivel3, group: {...nivel3.group, codNivel3: data.target.value} })} />
            </div>

            <div className='container-form'>
                <div className='label-form-group'>Nombre: </div>
                <input value={nivel3.group.name} className='label-form-group-data' onChange={data => setNivel3({ ...nivel3, group: {...nivel3.group, name: data.target.value} })} />
            </div>

            <div className='container-form'>
                <div className='label-form-group'>Descripción: </div>
                <textarea className='label-form-group-data' value={nivel3.group.descrp} onChange={data => setNivel3({ ...nivel3, group: {...nivel3.group, descrp: data.target.value} })}/>
            </div>

            <div className='container-form'>
                <div className='label-form-group'>Direccion (opcional): </div>
                <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
                    <input
                        value={nivel3.group.direccion || ''}
                        className='label-form-group-data'
                        style={{ flex: 1 }}
                        placeholder="Ej: Av. Corrientes 1234, CABA"
                        onChange={e => setNivel3({...nivel3, group: {...nivel3.group, direccion: e.target.value, lat: null, lng: null}})}
                    />
                    {nivel3.group.direccion && !nivel3.group.lat && (
                        <button type="button" className="geocodeBtnOPD" onClick={handleGeocodificar}>Validar</button>
                    )}
                    {nivel3.group.lat && <span style={{ color: 'green', fontSize: '0.8rem' }}>&#10003; Validada</span>}
                </div>
            </div>

            <div className='container-form'>
                <div className='label-form-group'>Nivel2: </div>
                <Select
                    styles={{
                        input: (base) => ({
                            ...base,
                            width: "100%",
                            padding: ".4rem",
                            borderRadius: ".5rem",
                            fontSize: "1rem",
                            transition: "border-color .5s"
                        })
                    }}
                    isDisabled={true}
                    placeholder="Elija el nivel1 que corresponda..."
                    options={optionsNivel2}
                    value={areaSeleccionadaNormalizada}
                    onChange={handleChange}
                    
                />
            </div>

            <div className='container-btn-group'>
                <button className='btn-form-group' style={{backgroundColor: COLOR_BOTONES, color:NAVBARS}} onClick={(titulo !== "Modificar") ? handlerGenerar : handlerModificar}>{titulo}</button>
                {
                    (data !== "") &&(
                        <button className='btn-eliminar-form-group' onClick={handlerEliminar}>Eliminar</button>
                    )

                }
                 {
                    titulo === "Modificar" ? (
                        <button className='btn-cancel-form-group' onClick={() => minimizar(data)}>Cancelar</button>
                    ) : (
                        <button className='btn-cancel-form-group' onClick={() => minimizar(formDato.activoNivel3)}>Cancelar</button>
                    )
                }
            </div>
        </div>
  )
}

export default FormNivel3;